import BaseService from '../../base/base_service';
import DOM from '../../utils/dom';
import Event from '../../utils/event';
import {SYSTEM_EVENTS} from '../../events/events';

class PostMessageService extends BaseService {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'PostMessageService';


    /**
     *
     * @param params
     */
    init(params) {
        super.init(params);

        this._onListenEvent();
    }


    /**
     * Getting the post message object, and should get in the event.data a function name
     * And the listener should redirect and fire the specifiec function if it exist in the
     * Post messages.
     *
     * @param postEvent
     * @public
     */
    listener(postEvent) {
        if (!postEvent) {
            this.logger.error('The incoming event in undefined');
            return;
        }

        this.logger.debug(postEvent);
        Event.fire(SYSTEM_EVENTS.POST_MESSAGE_ARRIVE, postEvent);
    }


    /**
     * Listen to the message event, and when it kick in the listener function should fire.
     *
     * @private
     */
    _onListenEvent() {
        if (window.addEventListener) {
            DOM.addEventListener(window, 'message', this.listener.bind(this), false);
        } else {
            // IE shits..
            window.attachEvent('onmessage', this.listener.bind(this));
        }
    }


    /**
     * Send post message
     */
    sendPostMessage(targetWindow, message = {}, targetOrigin = "*"){
        this.logger.info('Send post message', message);
        targetWindow.postMessage(message, targetOrigin);
    }
}


export default PostMessageService;